import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/da235btv7gurs51ef54g";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // 蜜罐检测：有值则不提交，并给出与正常提交一致的反馈
    const honeypot = (formData.get("phone_alt") as string)?.trim() || "";
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }

    // 校验邮箱非空
    const email = (formData.get("email") as string)?.trim() || "";
    if (!email) {
      setStatus("error");
      setFormError("请填写你的邮箱地址后再提交。");
      return;
    }

    // 构建不含蜜罐字段的请求体
    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== "phone_alt" && typeof value === "string" && value.trim() !== "") {
        payload.append(key, value);
      }
    });

    setStatus("loading");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.code || responseText;
      const isSpam = typeof serverMsg === "string" && /spam/i.test(serverMsg);
      const ok = res.ok && parsed?.code === "OK" && !isSpam;

      if (ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(typeof serverMsg === "string" && serverMsg ? serverMsg : "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请检查网络后重试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20gold%20ink%20splash%20with%20flying%20comic%20sparks%20and%20vibrant%20energy%20whirls%2C%20stylized%20celebratory%20background%2C%20minimal%20elegant%20meme%20vibe%2C%20high%20detail&width=1800&height=700&seq=subscribe-banner&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-foreground-950/75"></div>

      <div className="relative mx-auto w-full max-w-3xl px-4 py-6 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-400">
          <i className="ri-mail-send-fill"></i>
          订阅新梗
        </span>
        <h2 className="mt-2 font-heading text-3xl text-background-50 md:text-4xl">
          每周高能，第一时间送达
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-background-200 md:text-base">
          留下邮箱，每期爆款合集、沙雕图与弹幕梗更新后第一时间提醒你，绝不打扰、随时可退订。
        </p>

        {status === "success" ? (
          <div className="mx-auto mt-8 flex max-w-md flex-col items-center gap-3 rounded-lg border border-secondary-500/40 bg-background-50/10 p-6 backdrop-blur-sm">
            <i className="ri-checkbox-circle-fill text-4xl text-secondary-400"></i>
            <p className="text-base text-background-50">订阅成功！火影黄本子见～</p>
            <button
              type="button"
              onClick={() => setStatus("idle")}
              className="whitespace-nowrap rounded-md border border-background-100/40 px-4 py-2 text-sm text-background-50 hover:bg-background-50/10"
            >
              再订一个
            </button>
          </div>
        ) : (
          <form
            data-readdy-form="da235btv7gurs51ef54g"
            onSubmit={handleSubmit}
            className="mx-auto mt-8 max-w-xl"
          >
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                name="email"
                autoComplete="email"
                required
                placeholder="输入你的邮箱地址"
                className="h-12 flex-1 rounded-md border border-background-100/30 bg-background-50/10 px-4 text-sm text-background-50 placeholder:text-background-300 focus:border-secondary-400 focus:outline-none"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
              >
                {status === "loading" ? "提交中…" : "订阅新梗"}
              </button>
            </div>
            {/* 反垃圾蜜罐字段 */}
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="field-silencer"
            />
            {status === "error" && (
              <p className="mt-3 text-sm text-accent-400">{formError}</p>
            )}
          </form>
        )}

        <p className="mt-6 text-xs text-background-300">
          我们重视你的隐私，邮箱仅用于接收更新提醒，绝不会泄露给任何第三方。
        </p>
      </div>
    </section>
  );
}